export const siteSettings = {
  name: "TraxWaves",
  link: "https://traxwaves.com",
  email: "support@traxwaves.com",
  appLink: "https://app.traxwaves.com",
};
